module.exports = __webpack_public_path__ + "static/media/35-3.61a06d24.mp3";